module.exports = __webpack_public_path__ + "static/media/circle.2a46ccf4.svg";